/* src/app/shared/ui-kit/pa-uploadfile-button/pa-uploadfile-button.component.scss */
::ng-deep .p-fileupload .p-button-label {
  display: none;
}
::ng-deep .p-fileupload-basic {
  justify-content: start !important;
}
::ng-deep .p-fileupload-choose-button {
  padding: 10px !important;
  border-radius: 20px !important;
}
.file-list {
  list-style: none;
  padding: 0;
}
.file-list li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.file-list li:not(:last-child) {
  margin-bottom: 14px;
}
.file-list li .file-item {
  display: flex;
  flex-direction: row;
  gap: 14px;
}
.file-list li .file-item .file-image-wrapper .file-image.image {
  cursor: pointer;
}
.file-list li .file-item .file-image-wrapper .file-image {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 8px;
}
.file-list li .file-item .file-image-wrapper .file-image img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.file-list li .file-item .file-image-wrapper .file-image i {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  background-color: var(--secondary-subtle-default);
  color: var(--secondary-subtle-inverse);
}
.file-list li .file-item .file-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.file-list li .file-item .file-info .file-name,
.file-list li .file-item .file-info .file-size {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.file-list li .file-actions {
  display: flex;
  gap: 0.5rem;
}
/*# sourceMappingURL=pa-uploadfile-button.component.css.map */
